// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".package-type[data-v-6af72723]{grid-area:package-type;margin-top:-2px}.package-type__qty[data-v-6af72723]{top:-3px;right:-5px;border-radius:50%;width:17px;height:17px;background:#36134a;z-index:1}", ""]);
// Exports
module.exports = exports;
